import { render, staticRenderFns } from "./MMP_NewGroupModal.vue?vue&type=template&id=21ac175a&"
import script from "./MMP_NewGroupModal.vue?vue&type=script&lang=js&"
export * from "./MMP_NewGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./MMP_NewGroupModal.vue?vue&type=style&index=0&id=21ac175a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports